import { lazyWithPreload } from 'Helpers/lazyWithPreload.ts';

export const SignIn = lazyWithPreload(() =>
    import('./SignIn.tsx').then((m) => ({ default: m.SignIn }))
);
export const AuthUserTypeSelect = lazyWithPreload(() =>
    import('./AuthUserTypeSelect.tsx').then((m) => ({ default: m.AuthUserTypeSelect }))
);
export const SignUp = lazyWithPreload(() =>
    import('./SignUp.tsx').then((m) => ({ default: m.SignUp }))
);
